import { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import useDidUpdateEffect from '../../../../../common/hooks/useDidUpdateEffect'
import { Element } from '../../../../../common/html/element'
import { SelectCustom } from '../../../../../common/selectCustom'
import { debounce } from '../../../../../helpers/common'
import { Input } from '../../../../../library/common/html/input'
import { DateRangeCustom } from '../../../../common/html/DateRangeCustom'
import { TYPE_REPORTS_SELECT } from '../../constant'
import classes from '../../index.module.scss'
import {
  changeFilterTable,
  changeTypeReport,
  getFilterTable,
  selectTypeReport,
} from '../../store/slice'

export const FilterLatestReports = () => {
  const dispatch = useDispatch()

  const typeReport = useSelector(selectTypeReport)
  const from = useSelector(getFilterTable('StartDate'))
  const to = useSelector(getFilterTable('EndDate'))
  const text = useSelector(getFilterTable('Term'))

  const [inputValue, setInputValue] = useState(text)

  //Actions
  const handleSelectTypeReport = (value) => {
    dispatch(changeTypeReport(value))
    dispatch(
      changeFilterTable({
        Page: 1,
      }),
    )
  }

  const changeText = useCallback(
    debounce((value) => {
      dispatch(
        changeFilterTable({
          Term: value.trim(),
          Page: 1,
        }),
      )
    }, 200),
    [],
  )

  const onFromChange = (value) => {
    dispatch(
      changeFilterTable({
        StartDate: value,
        Page: 1,
      }),
    )
  }
  const onToChange = (value) => {
    dispatch(
      changeFilterTable({
        EndDate: value,
        Page: 1,
      }),
    )
  }

  //useEffect
  useDidUpdateEffect(() => {
    changeText(inputValue)
  }, [inputValue])

  return (
    <div className="dFlex">
      <Element
        className={`${classes.selectRpTable} dFlex alignItemsCenter`}
        style={{ borderRight: '1px solid #D5D5D5' }}
      >
        <Element
          style={{
            color: '#191D25',
            lineHeight: '16px',
            paddingRight: 12,
          }}
        >
          <Translate value="dashboard.latestReport.category" />:
        </Element>
        <div>
          <SelectCustom
            activeItem={typeReport}
            data={Object.values(TYPE_REPORTS_SELECT)}
            chooseItem={handleSelectTypeReport}
            style={{
              borderRadius: 2,
              paddingTop: 5,
              paddingBottom: 5,
              minWidth: 200,
            }}
            isI18n
          />
        </div>
      </Element>
      <Element
        className={classes.selectRpTable}
        style={{ borderRight: '1px solid #D5D5D5' }}
      >
        <Input
          isSearch
          style={{
            borderRadius: 2,
            minWidth: 200,
          }}
          value={inputValue}
          onChange={setInputValue}
          placeHolder="dashboard.latestReport.placeHolderSearch"
        />
      </Element>
      <div className="dFlex alignItemsCenter">
        <Element
          style={{
            color: '#191D25',
            lineHeight: '16px',
            paddingRight: 4,
            whiteSpace: 'nowrap',
          }}
        >
          <Translate value="dashboard.latestReport.publicDate" />:
        </Element>
        <div className="dFlex gap1">
          <DateRangeCustom
            onFromChange={onFromChange}
            onToChange={onToChange}
            fromDate={from}
            toDate={to}
            placeholderTo="dd-mmm-yyyy"
            placeholderFrom="dd-mmm-yyyy"
          />
        </div>
      </div>
    </div>
  )
}
